import { render } from "./ChangeExcessPremiumImpact.vue?vue&type=template&id=01cc6779&scoped=true"
import script from "./ChangeExcessPremiumImpact.vue?vue&type=script&lang=js"
export * from "./ChangeExcessPremiumImpact.vue?vue&type=script&lang=js"

import "./ChangeExcessPremiumImpact.vue?vue&type=style&index=0&id=01cc6779&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cc6779"]])

export default __exports__